import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { naturalSort } from '@mode/shared/util-js';
import { chunk } from 'lodash';

const PAGE_SIZE = 10;

export interface DataReference {
  default_access: DataReferenceAccessLevel;
  name: {
    text: string;
    href: string;
    type: DataReferenceType;
  };
  query: {
    text: string;
    href: string;
  };
}

export enum DataReferenceAccessLevel {
  View = 'View',
  Query = 'Query',
  None = 'None',
}
export enum DataReferenceType {
  Dataset = 'dataset',
  Datasource = 'datasource',
}

@Component({
  selector: 'mode-report-data-table',
  templateUrl: './report-data-table.component.html',
  styleUrls: ['./report-data-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportDataTableComponent implements OnChanges {
  displayedColumns: string[] = ['name', 'default_access', 'query'];
  paginatedReferences: DataReference[][] = [];
  currentPage = 1;

  pageSizeStart = 0;
  pageSizeEnd = 0;

  @Input() sortDisabled = false;

  @Input() references: DataReference[] | undefined;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.references) {
      this.paginatedReferences = this.getPaginatedReferences(changes.references.currentValue);
      this.updatePaginatorRange(this.currentPage);
    }
  }

  getPaginatedReferences(references: DataReference[] = []): DataReference[][] {
    const sortedReferences = this.getSortedReferences(references);
    return chunk(sortedReferences, PAGE_SIZE);
  }

  getSortedReferences(references: DataReference[] | null): DataReference[] {
    if (references) {
      if (this.sortDisabled) {
        return references;
      } else {
        // Sort with the same algorithm that queries are in the
        // editor with {@link Utils.naturalSort()}
        return references.sort((a: DataReference, b: DataReference) => {
          return naturalSort(a.name?.text, b.name?.text) || naturalSort(a.query?.text, b.query?.text);
        });
      }
    }

    return [];
  }

  handleChangeCurrentPage(newPageNumber: number) {
    this.currentPage = newPageNumber;
    this.updatePaginatorRange(newPageNumber);
  }

  private updatePaginatorRange(pageNumber: number) {
    if (this.references?.length) {
      this.pageSizeStart = (pageNumber - 1) * PAGE_SIZE + 1;
      this.pageSizeEnd = this.references.slice(0, pageNumber * PAGE_SIZE).length;
    }
  }
}
